const Phaser = window?.Phaser;
export class Menu extends window.Phaser.Scene {
  constructor() {
    super('menu');
    this.numPlayers = 1;
    this.gameMode = 0; // endless is 0, blitz is 1
    this.activeRow = 2; // 0:numPlayers,1:gameMode,2:start,3:howToPlay
    this.wasUp = false;
    this.wasDown = false;
    this.wasLeft = false;
    this.wasRight = false; // for joysticks
  }

  preload() {
    this.load.bitmapFont(
      'pixelfont',
      '/assets/delivery-guy/peaberry.png',
      '/assets/delivery-guy/peaberry.xml?v=2'
    );
    this.load.image('start-screen', '/assets/delivery-guy/start-screen.png');
    this.load.image('start-button', '/assets/delivery-guy/start-button.png');
    this.load.image('title', '/assets/delivery-guy/deliveryguy.png');
    this.load.image('block', '/assets/delivery-guy/block.png');

    this.load.audio('start', '/assets/delivery-guy/start.wav');
    this.load.audio('apple', '/assets/delivery-guy/apple.wav');
    this.load.audio('orange', '/assets/delivery-guy/orange.wav');
    this.load.audio('pear', '/assets/delivery-guy/pear.wav');
    this.load.audio('banana', '/assets/delivery-guy/banana.wav');
    this.load.audio('ouch', '/assets/delivery-guy/ouch.wav');
    this.load.audio('forward', '/assets/delivery-guy/fwd.wav');
    this.load.audio('back', '/assets/delivery-guy/bak.wav');
  }

  create() {
    this.gameWidth = this.sys.game.canvas.width;
    this.gameHeight = this.sys.game.canvas.height;

    // this.add.image(this.gameWidth / 2, this.gameHeight / 4, 'title');

    const bg = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        'start-screen'
      )
      .setDisplaySize(this.cameras.main.width, this.cameras.main.height);

    // this.add
    //   .bitmapText(
    //     this.gameWidth / 2,
    //     this.gameHeight - 56,
    //     'pixelfont',
    //     'Game by Christian Montoya',
    //     16
    //   )
    //   .setOrigin(0.5, 0.5)
    //   .setAlpha(0.7);
    // this.add
    //   .bitmapText(
    //     this.gameWidth / 2,
    //     this.gameHeight - 28,
    //     'pixelfont',
    //     'Art by Gabe Fern / tumblr.com/gabefern',
    //     16
    //   )
    //   .setOrigin(0.5, 0.5)
    //   .setAlpha(0.7);

    // this.playerText = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 - 4,
    //     this.gameHeight / 2 - 20,
    //     'pixelfont',
    //     'Players: ',
    //     16
    //   )
    //   .setOrigin(1, 0.5);
    // this.player1Button = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 + 4,
    //     this.gameHeight / 2 - 20,
    //     'pixelfont',
    //     '1',
    //     16
    //   )
    //   .setOrigin(0, 0.5)
    //   .setInteractive({ useHandCursor: true })
    //   .on('pointerdown', () => this.setNumPlayers(1));
    // this.player2Button = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 + 26,
    //     this.gameHeight / 2 - 20,
    //     'pixelfont',
    //     '2',
    //     16
    //   )
    //   .setOrigin(0, 0.5)
    //   .setInteractive({ useHandCursor: true })
    //   .on('pointerdown', () => this.setNumPlayers(2));
    // this.player3Button = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 + 48,
    //     this.gameHeight / 2 - 20,
    //     'pixelfont',
    //     '3',
    //     16
    //   )
    //   .setOrigin(0, 0.5)
    //   .setInteractive({ useHandCursor: true })
    //   .on('pointerdown', () => this.setNumPlayers(3));
    // this.player4Button = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 + 70,
    //     this.gameHeight / 2 - 20,
    //     'pixelfont',
    //     '4',
    //     16
    //   )
    //   .setOrigin(0, 0.5)
    //   .setInteractive({ useHandCursor: true })
    //   .on('pointerdown', () => this.setNumPlayers(4));
    // this.playerIndicator = this.add
    //   .image(this.gameWidth / 2 + 4, this.gameHeight / 2 - 6, 'block')
    //   .setOrigin(0, 0.5)
    //   .setScale(12, 2);
    this.playerRow = [
      this.playerText,
      this.player1Button,
      this.player2Button,
      this.player3Button,
      this.player4Button,
      this.playerIndicator,
    ];

    // this.playerHighlight = this.add.container(0, 0);
    // this.playerHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 - 94,
    //       this.gameHeight / 2 - 19,
    //       'pixelfont',
    //       '<',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );
    // this.playerHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 + 94,
    //       this.gameHeight / 2 - 19,
    //       'pixelfont',
    //       '>',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );

    // this.modeText = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 - 37,
    //     this.gameHeight / 2 + 16,
    //     'pixelfont',
    //     'Mode: ',
    //     16
    //   )
    //   .setOrigin(1, 0.5);
    // this.modeEndlessButton = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 - 29,
    //     this.gameHeight / 2 + 16,
    //     'pixelfont',
    //     'Endless',
    //     16
    //   )
    // .setOrigin(0, 0.5)
    // .setInteractive({ useHandCursor: true })
    // .on('pointerdown', () => this.setGameMode(0));
    // this.modeBlitzButton = this.add
    //   .bitmapText(
    //     this.gameWidth / 2 + 47,
    //     this.gameHeight / 2 + 16,
    //     'pixelfont',
    //     'Blitz',
    //     16
    //   )
    //   .setOrigin(0, 0.5)
    //   .setInteractive({ useHandCursor: true })
    //   .on('pointerdown', () => this.setGameMode(1));
    // this.modeIndicator = this.add
    //   .image(this.gameWidth / 2 - 29, this.gameHeight / 2 + 30, 'block')
    //   .setOrigin(0, 0.5)
    //   .setScale(67, 2);
    this.modeRow = [
      this.modeText,
      this.modeEndlessButton,
      this.modeBlitzButton,
      this.modeIndicator,
    ];

    //  this.modeHighlight = this.add.container(0, 0);
    // this.modeHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 - 103,
    //       this.gameHeight / 2 + 17,
    //       'pixelfont',
    //       '<',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );
    // this.modeHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 + 103,
    //       this.gameHeight / 2 + 17,
    //       'pixelfont',
    //       '>',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );

    // this.startButton = this.add
    //   .bitmapText(
    //     this.gameWidth / 2,
    //     this.gameHeight / 2 + 68,
    //     'pixelfont',
    //     'Start',
    //     32
    //   )
    //   .setOrigin(0.5, 0.5)
    this.startButton = this.add
      .image(this.gameWidth / 2, this.gameHeight / 2 + 158, 'start-button')
      .setOrigin(0.5, 0.5)
      .setInteractive({ useHandCursor: true })
      .once('pointerup', () => this.startGame())
      .setDisplaySize(180, 80);
    this.startHighlight = this.add.container(0, 0);
    // this.startHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 - 66,
    //       this.gameHeight / 2 + 70,
    //       'pixelfont',
    //       '<',
    //       32
    //     )
    //     .setOrigin(0.5, 0.5)
    // );
    // this.startHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 + 66,
    //       this.gameHeight / 2 + 70,
    //       'pixelfont',
    //       '>',
    //       32
    //     )
    //     .setOrigin(0.5, 0.5)
    // );

    this.howToPlayButton = this.add
      .bitmapText(
        this.gameWidth / 2,
        this.gameHeight / 2 + 238,
        'pixelfont',
        'HOW TO PLAY',
        16
      )
      .setOrigin(0.5, 0.5)
      .setInteractive({ useHandCursor: true })
      .once('pointerup', () => this.howToPlay());
    this.howToPlayHighlight = this.add.container(0, 0);
    // this.howToPlayHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 - 62,
    //       this.gameHeight / 2 + 119,
    //       'pixelfont',
    //       '<',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );
    // this.howToPlayHighlight.add(
    //   this.add
    //     .bitmapText(
    //       this.gameWidth / 2 + 62,
    //       this.gameHeight / 2 + 119,
    //       'pixelfont',
    //       '>',
    //       16
    //     )
    //     .setOrigin(0.5, 0.5)
    // );

    // set hightlights
    this.highlightRows();
    this.indicateNumPlayers();
    this.indicateGameMode();

    /* as for the keyboard, controls are explicitly mapped to various keys
     * arrows & wasd for movement, enter / spacebar / j/k/z/x for confirm!
     */
    this.input.keyboard.on('keyup', this.handleKeyboardAction, this);

    /* set up navigation / control events
     * in the menu, any gamepad can be used, and all events are tap-based
     * movement can be done with any joystick or d-pad, and any button can be used to confirm. there is no back button!
     */
    if (this.input.gamepad.total < 1) {
      this.input.gamepad.once(
        'connected',
        function (pad) {
          this.input.gamepad.on('up', this.handleGamePadButton, this);
        },
        this
      );
    } else {
      this.input.gamepad.on('up', this.handleGamePadButton, this);
    }

    this.events.on('shutdown', this.shutdown, this);
  }

  update() {
    // gamepad axes are processed here
    const pads = this.input.gamepad.gamepads;

    let inMotion = false;

    for (let i = 0; i < pads.length; i++) {
      const gamepad = pads[i];

      if (!gamepad) {
        continue;
      }

      let axes = '';
      for (let a = 0; a < gamepad.axes.length; a++) {
        const axis = gamepad.axes[a];
        const value = axis.getValue();
        if (0 !== value) {
          inMotion = true;
          if (this.wasRight || this.wasLeft || this.wasUp || this.wasDown) {
            continue;
          }
          if (axis.index % 2 == 0) {
            if (0 < value) {
              this.wasRight = true;
            } else {
              this.wasLeft = true;
            }
          } else {
            if (0 < value) {
              this.wasDown = true;
            } else {
              this.wasUp = true;
            }
          }
        }
      }
    }

    if (!inMotion) {
      if (this.wasRight) {
        this.goRight();
        this.wasRight = false;
      }
      if (this.wasLeft) {
        this.goLeft();
        this.wasLeft = false;
      }
      if (this.wasUp) {
        this.goUp();
        this.wasUp = false;
      }
      if (this.wasDown) {
        this.goDown();
        this.wasDown = false;
      }
    }
  }

  shutdown() {
    //  We need to clear keyboard and gamepad events, or they'll stack up when the Menu is re-run
    this.input.keyboard.shutdown();
    this.input.gamepad.shutdown();
    // console.log('menu shutdowned');
  }

  goRight() {
    if (this.activeRow === 0) {
      if (this.numPlayers < 4) {
        this.numPlayers++;
        this.indicateNumPlayers();
      }
    } else if (this.activeRow === 1) {
      if (this.gameMode === 0) {
        this.gameMode = 1;
        this.indicateGameMode();
      }
    }
  }

  goLeft() {
    if (this.activeRow === 0) {
      if (this.numPlayers > 1) {
        this.numPlayers--;
        this.indicateNumPlayers();
      }
    } else if (this.activeRow === 1) {
      if (this.gameMode === 1) {
        this.gameMode = 0;
        this.indicateGameMode();
      }
    }
  }

  goUp() {
    if (this.activeRow > 0) {
      this.activeRow--;
      this.highlightRows();
    }
  }

  goDown() {
    if (this.activeRow < 3) {
      this.activeRow++;
      this.highlightRows();
    }
  }

  action() {
    if (this.activeRow === 2) {
      this.startGame();
    } else if (this.activeRow === 3) {
      this.howToPlay();
    }
  }

  highlightRows() {
    // if (this.activeRow !== 0) {
    //   this.playerRow.forEach((item) => item.setAlpha(0.7));
    //   this.playerHighlight.setAlpha(0);
    // } else {
    //   this.playerRow.forEach((item) => item.setAlpha(1));
    //   this.playerHighlight.setAlpha(1);
    // }
    // if (this.activeRow !== 1) {
    //   this.modeRow.forEach((item) => item.setAlpha(0.7));
    //   this.modeHighlight.setAlpha(0);
    // } else {
    //   this.modeRow.forEach((item) => item.setAlpha(1));
    //   this.modeHighlight.setAlpha(1);
    // }
    // if (this.activeRow !== 2) {
    //   this.startButton.setAlpha(0.7);
    //   this.startHighlight.setAlpha(0);
    // } else {
    //   this.startButton.setAlpha(1);
    //   this.startHighlight.setAlpha(1);
    // }
    // if (this.activeRow !== 3) {
    //   this.howToPlayButton.setAlpha(0.7);
    //   this.howToPlayHighlight.setAlpha(0);
    // } else {
    //   this.howToPlayButton.setAlpha(1);
    //   this.howToPlayHighlight.setAlpha(1);
    // }
  }

  indicateNumPlayers() {
    // const delta = 4 + (this.numPlayers - 1) * 22;
    // this.playerIndicator.x = this.gameWidth / 2 + delta;
  }

  indicateGameMode() {
    // if (this.gameMode) {
    //   this.modeIndicator.setScale(48, 2);
    //   this.modeIndicator.x = this.gameWidth / 2 + 46;
    // } else {
    //   this.modeIndicator.setScale(67, 2);
    //   this.modeIndicator.x = this.gameWidth / 2 - 29;
    // }
  }

  handleKeyboardAction(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.W:
      case Phaser.Input.Keyboard.KeyCodes.UP:
        this.goUp();
        break;
      case Phaser.Input.Keyboard.KeyCodes.S:
      case Phaser.Input.Keyboard.KeyCodes.DOWN:
        this.goDown();
        break;
      case Phaser.Input.Keyboard.KeyCodes.A:
      case Phaser.Input.Keyboard.KeyCodes.LEFT:
        this.goLeft();
        break;
      case Phaser.Input.Keyboard.KeyCodes.D:
      case Phaser.Input.Keyboard.KeyCodes.RIGHT:
        this.goRight();
        break;
      case Phaser.Input.Keyboard.KeyCodes.J:
      case Phaser.Input.Keyboard.KeyCodes.K:
      case Phaser.Input.Keyboard.KeyCodes.SPACE:
        this.action();
        break;
      case Phaser.Input.Keyboard.KeyCodes.ENTER:
        this.action();
        break;
    }
  }

  handleGamePadButton(pad, button, value) {
    switch (button.index) {
      case 12:
        this.goUp();
        break;
      case 13:
        this.goDown();
        break;
      case 14:
        this.goLeft();
        break;
      case 15:
        this.goRight();
        break;
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        this.action();
        break;
      case 9:
        this.action();
        break;
    }
  }

  setNumPlayers(num) {
    this.numPlayers = num;
    this.indicateNumPlayers();
  }

  setGameMode(num) {
    this.gameMode = num;
    this.indicateGameMode();
  }

  startGame() {
    // console.log('starting game');
    this.sound.play('start');
    if (this.numPlayers < 2) {
      // 1 player mode
      if (this.gameMode < 1) {
        // console.log("starting single player endless");
        this.scene.start('singlePlayerEndless');
      } else {
        // console.log("starting single player blitz");
        this.scene.start('singlePlayerBlitz');
      }
    } else {
      // going multiplayer
      if (this.gameMode < 1) {
        // console.log("starting multi player endless");
        this.scene.start('multiPlayerEndless', { numPlayers: this.numPlayers }); // with num players
      } else {
        // console.log("starting multi player blitz");
        this.scene.start('multiPlayerBlitz', { numPlayers: this.numPlayers }); // with num players
      }
    }
  }

  howToPlay() {
    this.sound.play('forward');
    this.scene.start('tutorial');
  }
}
